import { render, staticRenderFns } from "./StudyQuizQuestionDiagnosed.vue?vue&type=template&id=70cb9305"
import script from "./StudyQuizQuestionDiagnosed.vue?vue&type=script&lang=js"
export * from "./StudyQuizQuestionDiagnosed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports